import {useEffect} from 'react';
import {IProduct} from '../../../../../../types/galleryTypes';
import {AddToCartActionStatus} from '../../../../../../constants';
import {useGlobals} from '../../../../../../globalPropsContext';

export const useAutoAddToCart = ({
  product,
  quantity,
  canAddProductToCart,
}: {
  product: IProduct;
  quantity: number;
  canAddProductToCart: boolean;
}) => {
  const {styles, stylesParams, addedToCartStatus, handleQuickAddToCart, isEditorMode} = useGlobals();
  const isQuickAddShowAddToCartButtonEnabled = styles.get(stylesParams.gallery_quickAddShowAddToCartButton);

  useEffect(() => {
    const isAlreadyAddingToCart = addedToCartStatus[product.id] === AddToCartActionStatus.IN_PROGRESS;
    const isAddToCartButtonHidden = !isQuickAddShowAddToCartButtonEnabled;
    const shouldAddToCart = !isEditorMode && !isAlreadyAddingToCart && isAddToCartButtonHidden && canAddProductToCart;

    if (shouldAddToCart) {
      void handleQuickAddToCart({product, productId: product.id, quantity});
    }
  }, [
    isQuickAddShowAddToCartButtonEnabled,
    addedToCartStatus,
    canAddProductToCart,
    handleQuickAddToCart,
    product,
    quantity,
    isEditorMode,
  ]);
};
